// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"82d5642d","196":"8e9174bd","282":"03aa52f2","563":"523db3b9","951":"ec09c042"}[chunkId] + ".chunk.js";
};